var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartOutlineRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5167 17.3417C10.2333 17.4417 9.76667 17.4417 9.48333 17.3417C7.06667 16.5167 1.66667 13.075 1.66667 7.24167C1.66667 4.66667 3.74167 2.58333 6.3 2.58333C7.81667 2.58333 9.15833 3.31667 10 4.45C10.8417 3.31667 12.1917 2.58333 13.7 2.58333C16.2583 2.58333 18.3333 4.66667 18.3333 7.24167C18.3333 13.075 12.9333 16.5167 10.5167 17.3417Z",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutlineRed);
export default __webpack_public_path__ + "static/media/heart-outline-red.d6959b089792ec2b1361257eaa9e0b2c.svg";
export { ForwardRef as ReactComponent };